import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CountryCode } from '@bca-user-data/models/_enums';
import { ICountry } from '@bca-user-data/models/country';

@Component({
  selector: 'bca-choose-country',
  templateUrl: 'choose-country.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseCountryComponent {
  @Input()
  userForm: FormGroup;
  @Input()
  countries: ICountry[];
  @Input()
  selectedCountryCode: CountryCode;

  @Output()
  selected = new EventEmitter<CountryCode>();

}
